// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__t_IyV","productName":"Table_productName__2vHcx"};